module.exports = __webpack_public_path__ + "static/media/checkbox-unchecked.d728f6fb.svg";